/**
 * Candidate Tracker Column Definitions
 * Organized by category: Personal Info, Job Info, Pipeline Info, Other Info
 */

export const CANDIDATE_STAGES = [
  'New',
  'Phone Screen',
  'Submitted to HM',
  'HM 1st Interview',
  'HM 2nd Interview',
  'Market Visit',
  'Offer Extended',
  'Offer Accepted',
  'Hired'
];

export const PRIORITY_OPTIONS = [
  'Low',
  'Medium',
  'High',
  'Urgent'
];

export const CANDIDATE_SOURCES = [
  'LinkedIn',
  'Indeed',
  'Referral',
  'Career Site',
  'Job Board',
  'Recruiter Outreach',
  'Event/Career Fair',
  'Internal Transfer',
  'Other'
];

export const RECRUITER_OPTIONS = [
  'Amy Harrington',
  'Sherry Chucks',
  'Samuel Duhaime'
];

export const REJECTION_REASONS = [
  'Qualifications',
  'Experience Level',
  'Compensation Expectations',
  'Location',
  'Culture Fit',
  'Availability',
  'Failed Background Check',
  'Candidate Withdrew',
  'Position Filled',
  'Other'
];

export const CANDIDATE_COLUMNS = [
  // Personal Information
  {
    key: 'candidate_name',
    label: 'Candidate Name',
    type: 'text',
    required: true,
    width: 180,
    category: 'personal'
  },
  {
    key: 'candidate_email',
    label: 'Email',
    type: 'email',
    width: 200,
    category: 'personal'
  },
  {
    key: 'candidate_phone_number',
    label: 'Phone',
    type: 'tel',
    width: 140,
    category: 'personal'
  },
  {
    key: 'candidate_source',
    label: 'Source',
    type: 'select',
    options: CANDIDATE_SOURCES,
    width: 150,
    category: 'personal'
  },
  {
    key: 'referred_by',
    label: 'Referred By',
    type: 'text',
    width: 150,
    category: 'personal'
  },

  // Job Information
  {
    key: 'standard_job_title',
    label: 'Job Title',
    type: 'text',
    width: 180,
    category: 'job'
  },
  {
    key: 'job_location',
    label: 'Location',
    type: 'select',
    options: [],
    width: 180,
    category: 'job',
    isJobField: true
  },
  {
    key: 'hiring_manager',
    label: 'Hiring Manager',
    type: 'text',
    width: 160,
    category: 'job'
  },
  {
    key: 'assigned_recruiter',
    label: 'Assigned Recruiter',
    type: 'select',
    options: RECRUITER_OPTIONS,
    width: 160,
    category: 'job'
  },
  {
    key: 'priority',
    label: 'Priority',
    type: 'select',
    options: PRIORITY_OPTIONS,
    width: 120,
    category: 'job'
  },

  // Pipeline/Stage Information
    {
    key: 'candidate_stage',
    label: 'Stage',
    type: 'select',
    options: CANDIDATE_STAGES,
    width: 150,
    category: 'pipeline'
  },
  {
    key: 'phone_screen_date',
    label: 'Phone Screen Date',
    type: 'date',
    width: 140,
    category: 'pipeline'
  },
  {
    key: 'submittal_date',
    label: 'Submittal Date',
    type: 'date',
    width: 140,
    category: 'pipeline'
  },
  {
    key: 'hm_first_interview',
    label: 'HM 1st Interview',
    type: 'date',
    width: 140,
    category: 'pipeline'
  },
  {
    key: 'hm_second_interview',
    label: 'HM 2nd Interview',
    type: 'date',
    width: 140,
    category: 'pipeline'
  },
  {
    key: 'market_visit_date',
    label: 'Market Visit Date',
    type: 'date',
    width: 140,
    category: 'pipeline'
  },
  {
    key: 'offer_extended_date',
    label: 'Offer Extended Date',
    type: 'date',
    width: 140,
    category: 'pipeline'
  },
  {
    key: 'offer_accepted_date',
    label: 'Offer Accepted Date',
    type: 'date',
    width: 140,
    category: 'pipeline'
  },
  {
    key: 'hired_date',
    label: 'Hired Date',
    type: 'date',
    width: 140,
    category: 'pipeline'
  },
  {
    key: 'interviewers',
    label: 'Interviewer(s)',
    type: 'text',
    width: 180,
    category: 'pipeline'
  },

  // Other Information
  {
    key: 'notes',
    label: 'Notes',
    type: 'textarea',
    width: 250,
    category: 'other'
  },
  {
    key: 'rejection_reason',
    label: 'Rejection Reason',
    type: 'select',
    options: REJECTION_REASONS,
    width: 160,
    category: 'other'
  },
  {
    key: 'rejection_reason_details',
    label: 'Rejection Details',
    type: 'textarea',
    width: 200,
    category: 'other'
  },
  {
    key: 'ta_follow_up_reminder_date',
    label: 'Follow-up Reminder',
    type: 'date',
    width: 150,
    category: 'other'
  }
];

// Helper function to get columns by category
export const getColumnsByCategory = (category) => {
  return CANDIDATE_COLUMNS.filter(col => col.category === category);
};

// Helper function to get all column keys
export const getAllColumnKeys = () => {
  return CANDIDATE_COLUMNS.map(col => col.key);
};
